import request from "@/router/axios";
export const list = () => {
  return request({
    url: `/api/bed/ward/list`,
    method: "post",
    data: {
      filterParams: [
        { name: "isValid", value: true },
      ],
      orderBy: "id",
      isDesc: true,
    },
  });
};
export const getWardQueues = () => {
  return request({
    url: `/api/bed/ward/getWardQueues`,
    method: "get",
  });
};
export const getWardGroupQueues = (wardId, doctorId) => {
  return request({
    url: `/api/bed/ward/getWardGroupQueues`,
    method: "get",
    params: {
      wardId,
      doctorId,
    },
  });
};
export const getWards = () => {
  return request({
    url: `/api/bed/ward/getWards`,
    method: "get",
  });
};

export const getWardQueue = (wardId) => {
  return request({
    url: `/api/bed/wardQueue/getWardQueue`,
    method: "get",
    params: {
      wardId,
    },
  });
};
export const sortWardQueue = (data) => {
  return request({
    url: `/api/bed/wardQueue/sortWardQueue`,
    method: "post",
    data,
  });
};
export const getWardGroups = (wardId) => {
  return request({
    url: `/api/bed/wardGroup/getWardGroups`,
    method: "get",
    params: {
      wardId,
    },
  });
};

export const saveGroup = (data) => {
  return request({
    url: `/api/bed/wardGroup/saveGroup`,
    method: "post",
    data,
  });
};

export const removeGroup = (wardId, groupId) => {
  return request({
    url: `/api/bed/wardGroup/removeGroup`,
    method: "post",
    params: {
      wardId,
      groupId,
    },
  });
};
export const sortWardGroup = (data) => {
  return request({
    url: `/api/bed/wardQueue/sortWardGroup`,
    method: "post",
    data,
  });
};
export const verifyWardGroup = (data) => {
  return request({
    url: `/api/bed/wardQueue/verifyWardGroup`,
    method: "post",
    data,
  });
};
